<template>
  <v-row xs12 pt-2 class="search-fields" column v-on:keyup.enter="search">
    <v-flex xs4 px-1>
      <v-text-field
        @change="search"
        hide-details
        dense
        solo
        rounded
        v-model="query.search"
        label="Search"
      ></v-text-field>
    </v-flex>
    <v-flex xs4 px-2>
      <v-select
        dense
        v-if="rideTypes"
        v-model="query.rideType"
        :items="rideTypes"
        item-text="name"
        item-value="id"
        label="Ride Type"
        solo
        multiple
        hide-details
        rounded
        @change="search"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0">{{ item.name }}</span>
          <span v-if="index === 1" class="grey--text caption"
            >(+{{ query.rideType.length - 1 }} others)</span
          >
        </template>
      </v-select>
    </v-flex>
    <v-flex xs4 px-2>
      <v-select
        hide-details
        dense
        v-model="query.plannerFilter"
        :items="plannerFilterItems"
        item-text="name"
        item-value="id"
        label="Filter By"
        solo
        rounded
        @change="search"
      />
    </v-flex>
    <v-flex xs4 px-2 py-2 v-if="showAllButton">
      <v-btn-toggle rounded v-model="query.showAll" @change="search"  class="px-1">
        <v-btn rounded small :value="true" type="primary" style="background: white" v-if="!query.showAll" >show all</v-btn>
        <v-btn rounded small :value="false" type="secondary" style="background: green !important; color: white" v-if="query.showAll" >show all</v-btn>
      </v-btn-toggle>
    </v-flex>
  </v-row>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_search_box",
  props: {
    query: Object,
    showAllButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      rideTypes: null,
      plannerFilterItems: [
        { name: "All", id: "filter_all" },
        { name: "Online", id: "filter_online" },
        { name: "Should Be Online", id: "filter_should_be_online" },
        { name: "Day Off", id: "filter_day_off" },
        { name: "Break", id: "filter_break" },
        { name: "Private Trip", id: "filter_private_trip" },
        { name: "Preassigned", id: "filter_preassigned" },
        { name: "Online Soon", id: "filter_online_soon" },
        { name: "Likely Working", id: "filter_likely_working" },
        { name: "Locked Out", id: "filter_locked_out" },
      ],
    };
  },
  mounted: async function () {
    this.getTaxiInformation();
  },
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
    getTaxiInformation: async function () {
      console.log("test");
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = [];
        // this.rideTypes.push({
        //   name: "",
        //   id: -1
        // });
        this.rideTypes = this.rideTypes.concat(response.data.ride_types);
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
